import { DATE_FILTER, FILTER_KEYWORDS } from "../consts";
import { SAMPLE_ORIGINS } from "../components/filters/consts";

export const queryOptions = {
  gcTime: 0,
  refetchOnWindowFocus: false,
  refetchOnMount: false
};

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 100;
export const DEFAULT_QUERY = "";
export const DEFAULT_LOCAL_SORT = "submission_time desc";
export const DEFAULT_CLOUD_SORT_SELECTION = {
  direction: "desc",
  field: "first_seen"
};

export const DEFAULT_LOCAL_TIME_SELECTIONS = {
  time_type: {
    value: FILTER_KEYWORDS.SUBMISSION_TIME,
    label: FILTER_KEYWORDS.SUBMISSION_TIME
  },
  period_type: {
    value: DATE_FILTER.LAST_MONTH,
    label: DATE_FILTER.LAST_MONTH
  },
  sample_origin: {
    value: SAMPLE_ORIGINS.TOP_CONTAINER,
    label: FILTER_KEYWORDS.SAMPLE_ORIGIN
  }
};
export const DEFAULT_CLOUD_TIME_SELECTION = {
  time_type: {
    value: FILTER_KEYWORDS.FIRST_SEEN,
    label: FILTER_KEYWORDS.FIRST_SEEN
  },
  period_type: {
    value: DATE_FILTER.LAST_MONTH,
    label: DATE_FILTER.LAST_MONTH
  }
};

export const DEFAULT_NETWORK_TIME_SELECTION = {
  time_type: {
    value: FILTER_KEYWORDS.SUBMISSION_TIME,
    label: FILTER_KEYWORDS.SUBMISSION_TIME
  },
  period_type: {
    value: DATE_FILTER.ALL,
    label: DATE_FILTER.ALL
  }
};
